const DashboardApiResources = {
  cancelBooking: 'dashboard/cancel_booking',
  changeBooking: 'dashboard/change_booking',
  completeBooking: 'dashboard/complete_booking',
};
export default DashboardApiResources;
